import _ from "lodash";
import Url from "../../Utils/Url"
import Services from "../../Services";
import {loader} from "../../Utils/Loader";
import {delay} from "../../Utils/Delay";
import Content from "../../templates/Product/Content";
const path = require("path");

const ProductSearchService = {
    addTOHistory: true,
    isChangedFilters: false,
    oldParams: {},
    isSorted: false,
    withoutPageLoader: false,
    container: '.js-search-products-container',
    priceRange: {
        isUpdated: false,
        isFiltered: false,
        default: [],
        changed: []
    },

    init: function () {
        const functions = [
            this.onLoadContent,
            this.initFilterControls,
            this.initPagination,
            this.initFilterRange,
            this.initSortOptions,
            this.preventSortOptionAction,
            this.initFilterSubmit,
            this.initUrlChange,
            this.initClearButton,
        ], self = this;

        for (let i = 0; i < functions.length; ++i) {
            try {
                functions[i].bind(self)();
            } catch (e) {
                console.warn(e);
            }
        }
    },

    setOldParams: function (oldParams) {
        if (_.has(oldParams, 'q')) {
            _.set(oldParams, 'q', encodeURI(decodeURI(_.get(oldParams, 'q'))))
        }
        this.oldParams = oldParams;
    },

    initialUrlState: function () {
        const currentUrl = new Url(Services.URL.fullWithoutOriginAndHash())
        this.initialURLByFilters(currentUrl.getParam('page', null) || this.oldParams?.page || undefined, true)

        this.setOldParams(this.url.getParams())
    },

    onLoadContent: function () {
        const $this = this
        $this.withoutPageLoader = true
        this.initialUrlState()
        delay().time(1000).handler(() => {
            $this.fetchData(true, false, $this.initStickySideBar);
        }).fire()
    },

    toggleLoader: function () {
        const filterButton = $(document).find('.js-filter-product-submit');
        if (filterButton.length > 0 && filterButton.hasClass('loading')) {
            filterButton.removeClass('loading').prop('disabled', false)
            loader().unblock('body')
            return;
        }
        filterButton.addClass('loading').prop('disabled', true)
        loader().block('body', {
            state: 'danger',
            message: 'کمی صبر کنید...',
            opacity: 0.5,
        })
    },

    initStickySideBar: function () {
        const sidebar = $(document).find('.js-sticky-sidebar-filters');
        if (sidebar.length > 0 && !sidebar.hasClass('dot-loader-hide')) {
            sidebar.delay(500).addClass('dot-loader-hide')
        }
    },

    reLoadContentLoader: function (data, callback, delay = 500) {
        const content = $(document).find(`${this.container} .product-items-wrapper`);
        const loader = content.children(`.dot-loader, dot-loader-sn`);
        if (loader.length > 0) {
            content.addClass('dot-loader-hide')
        }

        content.animate({'opacity': 0}, delay, function () {
            content.removeClass('dot-loader-wrapper').html(data).animate({'opacity': 1}, delay, callback);
        })
    },

    initFilterRange: function (reset, setValue) {
        const $this = this;
        let nonLinearStepSlider = $(document).find('#slider-non-linear-step')
        let min = nonLinearStepSlider.data('min')
        let max = nonLinearStepSlider.data('max')
        let min_start = (reset || Services.isEmpty(min_start = nonLinearStepSlider.data('filter-min'))) ? undefined : min_start;
        let max_start = (reset || Services.isEmpty(max_start = nonLinearStepSlider.data('filter-max'))) ? undefined : max_start;
        $this.priceRange.default = [min, max]
        nonLinearStepSlider = nonLinearStepSlider[0]

        if (_.isUndefined(nonLinearStepSlider)) {
            return
        }

        if (reset) {
            nonLinearStepSlider.noUiSlider.destroy();
            $this.priceRange.isFiltered = false;
            $this.priceRange.changed = [];
        }
        noUiSlider.create(nonLinearStepSlider, {
            start: [min, max],
            connect: true,
            direction: 'rtl',
            step: 500,
            format: wNumb({
                decimals: 0,
                thousand: ','
            }),
            range: {
                'min': [min],
                'max': [max]
            }
        });

        if (_.isArray(setValue) || (!_.isUndefined(min_start) && !_.isUndefined(max_start))) {
            $this.priceRange.isFiltered = true;
            let range = []
            if (_.isArray(setValue)) {
                if (setValue.length === 2) {
                    range = $this.priceRange.changed = setValue
                } else {
                    $this.priceRange.isFiltered = false;
                }
            } else {
                range = $this.priceRange.changed = [min_start, max_start]
            }

            nonLinearStepSlider.noUiSlider.set(range)
        }

        const nonLinearStepSliderValueElement = $(document).find('#slider-non-linear-step-value');

        nonLinearStepSlider.noUiSlider.on('update', function (values) {
            nonLinearStepSliderValueElement.html(values.join(' تا '));
        });
        nonLinearStepSlider.noUiSlider.on('change', function (values) {
            $this.priceRange.changed = (values.map(num => {
                return _.toNumber(num.replace(/\D/g, ''))
            }))
            $this.priceRange.isUpdated = true;
            $this.priceRange.isFiltered = true;

            $this.initPreventDuplicateRequest()
        });
    },

    preventSortOptionAction: function () {
        const $this = this;
        $(document).find(`${this.container} .js-sort-options .js-sort-option`).each(function () {
            if ($(this).hasClass('active')) {
                $this.isSorted = $(this).data('action') !== 'latest'
                $(this).attr('data-prevent-action', 'true')
            } else {
                $(this).attr('data-prevent-action', 'false')
            }
        })
    },

    initSortOptions: function () {
        const $this = this;
        const sort_options_query = `${this.container} .js-sort-options .js-sort-option`;
        const sort_options_elems = $(document).find(sort_options_query);

        sort_options_elems.on('click', function (e) {
            try {
                if (e.type === 'mousedown' && $(this).hasClass('active')) {
                    $(this).attr('data-prevent-action', 'true')
                    return;
                }
                if (e.type === 'click' && $(this).attr('data-prevent-action') === 'false') {
                    $this.preventSortOptionAction()
                    $this.getProductsForFilters();
                }
            } catch (e) {
                console.warn(e);
            }
        });
    },

    initFilterSubmit: function () {
        const $this = this;
        $(document).on('click', '.js-filter-product-submit', function (e) {
            try {
                $this.getProductsForFilters(1, true);
            } catch (e) {
                console.error(e);
            }
        });
    },

    getFilterByCategory: function () {
        let checkboxParams = {};
        $(`${this.container} .filter-product .js-filter-options .js-filter-category-items input:checked`).each(function () {
            let name = $(this).attr('name');
            if (name.slice(-2) === '[]') {
                name = $(this).attr('name').slice(0, -2);
                if (typeof checkboxParams[name] === 'undefined') {
                    checkboxParams[name] = [];
                }
                checkboxParams[name].push($(this).val());
            } else {
                checkboxParams[name] = $(this).val();
            }
        });
        return checkboxParams;
    },

    getFilterByBrand: function () {
        let checkboxParams = {};
        $(`${this.container} .filter-product .js-filter-options .js-filter-brand-items input:checked`).each(function () {
            let name = $(this).attr('name');
            if (name.slice(-2) === '[]') {
                name = $(this).attr('name').slice(0, -2);
                if (typeof checkboxParams[name] === 'undefined') {
                    checkboxParams[name] = [];
                }
                checkboxParams[name].push($(this).val());
            } else {
                checkboxParams[name] = $(this).val();
            }
        });
        return checkboxParams;
    },

    initClearButton: function () {
        const $this = this
        const $clearButton = $(document).find(`${$this.container} .filter-product .js-clear-filters`)
        const filterFlags = [
            $this.priceRange.isFiltered,
            $this.isSorted,
            ($(document).find(`${$this.container} .filter-product input[type=checkbox]:checked`).length > 0),
            ($(`${$this.container} .filter-product .widget-search input[name=q]`).val().length > 0)
        ];

        if (filterFlags.includes(true)) {
            $clearButton.fadeIn(500)
        } else {
            $clearButton.fadeOut(500)
        }
    },

    initFilterControls: function () {
        const $this = this
        let timeoutID = null

        $(document).on('submit', `${$this.container} .filter-product form.widget-search`, function (e) {
            e.preventDefault();
            $this.getProductsForFilters(1, true);
        });

        $(document).on('click', `${$this.container} .filter-product .js-clear-filters`, function (e) {
            e.preventDefault();
            $(this).closest('.filter-product').find('input[type=checkbox]').prop('checked', false);

            $(document).find(`${$this.container} .js-sort-options .js-sort-option`)
                .removeClass('active')
                .parent()
                .children(`.js-sort-option[data-action='latest']`)
                .addClass('active'); // set default value for ordering tabs

            $(`${$this.container} .filter-product .widget-search input[name=q]`)
                .val(''); // clear query search input

            $this.initFilterRange(true);
            $this.queryRemoved = true
            $this.isSorted = false
            $this.priceRange.isFiltered = false
            $this.preventSortOptionAction()
            $this.getProductsForFilters(1, true);
            $this.queryRemoved = false
        });

        $(document).on('change, click', `${$this.container} .filter-product input[type=checkbox]`, function () {
            $this.initPreventDuplicateRequest()
        });

        $(document).on('keyup', `${$this.container} .filter-product .widget-search input[type=text]`, function () {
            clearTimeout(timeoutID);
            timeoutID = setTimeout(() => $this.initPreventDuplicateRequest(), 500)
        });
    },

    initPreventDuplicateRequest: function (page) {
        let check;

        this.initialURLByFilters(page || this.oldParams?.page || undefined, true)

        const old = this.oldParams
        const now = this.url.getParams()

        if ((check = _.isEqual(old, now))) {
            $('.js-filter-product-submit').addClass('disabled').prop('disabled', true);
        } else {
            $('.js-filter-product-submit').removeClass('disabled').prop('disabled', false);
        }
        return check;
    },

    initialURLByFilters: function (page, validate) {
        const $this = this;
        let val, input_value;
        $this.url = new Url(Services.URL.path());

        // Filter By {categories & brands}
        let checkboxParams = _.assign({}, $this.getFilterByCategory(), $this.getFilterByBrand());
        if (!_.isEmpty(checkboxParams)) {
            $this.url.setParams(checkboxParams);
        }

        // Filter By {query search}
        const searchInput = $(`${$this.container} .filter-product .widget-search input[name=q]`);
        const url_queryString = new Url(Services.URL.queryString());
        if (!$this.queryRemoved && validate && (val = url_queryString.getParam('q'))) {
            if (!Services.isEmpty(input_value = searchInput.val())) {
                val = input_value
            }
            $this.url.setParam('q', decodeURI(val));
        } else if (((val = searchInput.val()) || (!$this.queryRemoved && url_queryString.getParam('q', null)))) {
            $this.url.setParam('q', val);
            // !validate && searchInput.val('');
        } else {
            $this.queryRemoved = false;
        }

        // Filter By {products has selling stock}
        const has_selling_stock = $(`${$this.container} .filter-product input[name=has_selling_stock]:checked`);
        if (has_selling_stock.length > 0) {
            $this.url.setParam('has_selling_stock', 1);
        }


        // Sorting By {latest || oldest || cheapest || most_expensive}
        const sort_item = $(`${$this.container} .js-sort-options .js-sort-option.active`).data('action');
        if (sort_item) {
            $this.url.setParam('sort_by', sort_item);
        }

        // Filter By {Price Range}
        $this.preparePriceFilter()

        // Set Pagination Number
        if (page) {
            $this.url.setParam('page', page);
        }
    },

    getProductsForFilters: function (page, scrollToTop) {
        const $this = this;

        if (this.initPreventDuplicateRequest(page)) {
            return
        }

        $this.initialURLByFilters(page)

        $this.initClearButton()

        $this.fetchData(scrollToTop, undefined)
    },

    preparePriceFilter: function () {
        const $this = this;
        let prices = {};
        let range_flag = ['min', 'max'];
        let range = $this.priceRange.changed;

        if (($this.priceRange.isUpdated || $this.priceRange.isFiltered) && (!_.isEmpty($this.priceRange.changed) && !_.isEqual($this.priceRange.default, $this.priceRange.changed))) {
            range.map((price, index) => {
                return prices[`price[${range_flag[index]}]`] = price
            })
        }
        if (!_.isEmpty(prices)) {
            $this.url.setParams(prices);
            $this.priceRange.isFiltered = true
        }
    },

    initUrlChange: function () {
        const $this = this;
        window.onpopstate = function () {
            const url = new Url(window.location);
            let pageNumber = undefined;
            $this.addTOHistory = false;
            const sort_options = $(document).find(`${$this.container} .js-sort-options`);
            const courseSearchInput = $(document).find(`${$this.container} .filter-product .widget-search input[name=q]`);
            $(`${$this.container} .filter-product input[type=checkbox]:checked`).prop("checked", false);
            sort_options.find('.js-sort-option').removeAttr('data-ah-tab-active');
            courseSearchInput.val('');

            const flags = ['has_selling_stock'];
            let price_range = []
            $.each(url.getParams(), function (name, value) {
                if (name === 'sort_by') {
                    sort_options.find(`.js-sort-option[data-action='${value}']`).attr('data-ah-tab-active', true);
                } else if (name === 'page') {
                    pageNumber = value;
                } else if (name === 'price[min]') {
                    $(document).find('#slider-non-linear-step').data('filter-min', value)
                    price_range.push(value)
                } else if (name === 'price[max]') {
                    $(document).find('#slider-non-linear-step').data('filter-max', value)
                    price_range.push(value)
                } else if (name === 'q') {
                    courseSearchInput.val(value);
                } else if (flags.indexOf(name) >= 0) {
                    $(`${$this.container} .filter-product input[type=checkbox][name=${name}]`).prop('checked', true);
                } else {
                    let elName = name.substring(0, name.lastIndexOf('['));
                    $(document).find(`${$this.container} .filter-product .js-filter-options input[type=checkbox][name='${elName}[]'][value='${value}']`).prop("checked", true);
                }
            });

            if (price_range) {
                $this.initFilterRange(true, price_range)
            }
            $this.getProductsForFilters(pageNumber, true);
            $this.addTOHistory = true;
        };
    },

    initPagination: function () {
        const $this = this;
        $(document).on('click', `${$this.container} .pagination-cm a.pagination-item`, function (e) {
            e.preventDefault();
            let page;
            if ((page = _.toNumber($(this).data('page'))) && !isNaN(page)) {
                $this.getProductsForFilters(page, true);
            }
        });
    },

    fetchData: function (scrollToTop, url, callback) {
        const $this = this;
        $this.setOldParams($this.url.getParams())
        $.ajax({
            url: path.join('/web/api/', url || $this.url.getUrl()),
            type: "GET",
            dataType: "json",
            beforeSend: function (jqxhr) {
                if ($this.jqxhr) {
                    $this.jqxhr.abort();
                }
                !$this.withoutPageLoader && $this.toggleLoader()
                if ($this.addTOHistory) {
                    $this.url.update();
                }
                $this.jqxhr = jqxhr;
            },
            success: function (response) {
                $this.reLoadContentLoader(new Content(response).render(), function () {
                    !$this.withoutPageLoader && $this.toggleLoader()
                    $this.withoutPageLoader = false;
                    _.isFunction(callback) && callback()
                    $this.initPreventDuplicateRequest()
                    Services.initTooltips()
                    if (scrollToTop) {
                        Services.scrollWindowToList();
                    }
                })
            },
            error: function (data) {
                !$this.withoutPageLoader && $this.toggleLoader()
                if (scrollToTop) {
                    Services.scrollWindowToList();
                }
            },
            complete: function () {
                $(".tooltip").tooltip("hide");
            }
        });
    }
}

export default ProductSearchService